import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import nManager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'
import apiConnector from '@/mixins/apiConnector'

export default {
  data () {
    return {
      requestedCampaign: null,
      campaignEvents: {}
    }
  },
  methods: {
    /**
     * Duplicates the given MPE
     * @param {String} id Id of the mpe
     * @param {String} eventType Advertisable's event type
     * @param {Boolean} withCampaign Link mpe to a campaign
     * @param {Object} meta Meta fields for new MPE's
     */
    duplicateMpe (id, eventType, withCampaign = false, meta = {}) {
      let name =  `createQuickPost`
      let params = {
        category: (eventType === 'post') ? 'news' : eventType,
        id,
        action: 'duplicate'
      }

      if (withCampaign) {
        params = { ...params, ...meta }
      }

      this.$router.push({ name, params })
    },

    /**
     * Duplicates the given Advertisable
     * @param {String} id Id of the advertisable
     * @param {String} eventType Advertisable's event type
     * @param {Boolean} withCampaign Link mpe to a campaign
     * @param {Object} meta Meta fields for new MPE's
     */
    duplicateAdvertisable (id, eventType, withCampaign = false, meta = {}) {
      let name =  `createQuickPost`
      let params = {
        category: (eventType === 'post') ? 'news' : eventType,
        id,
        action: 'duplicate_advertisable'
      }

      if (withCampaign) {
        params = { ...params, ...meta }
      }

      this.$router.push({ name, params })
    },

    /**
     * Duplicates the given Campaign. First it pulls advertisables
     * @param {String} id Campaign's id
     * @param {String} type Campaign's type
     */
    duplicateCampaign (id, type) {
      let categories = {
        dailyDeal: 'dailyDeal',
        productPromotion: 'promoteProduct',
        sale: 'saleProduct'
      }
      let category = categories[type]
      this.$router.push({ name: 'createCampaign', params: { category, id, action: 'duplicate' } })
    }
  },

  mixins: [
    apiConnector
  ]
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/duplicator.js